// extracted by mini-css-extract-plugin
export default {"cartButton":"CartButton_cartButton__lflLf","cartIcon":"CartButton_cartIcon__JoEzp","badge":"CartButton_badge__S+wRF"};